import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=7db94609&lang=pug&"
import script from "./Initial.vue?vue&type=script&lang=ts&"
export * from "./Initial.vue?vue&type=script&lang=ts&"
import style0 from "./Initial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports